export const COLUMN_NAMES = {
    MAIN: 'Main',
    OTHERS: 'Others',
}
